import React, { useState, useEffect } from 'react'

import Grid from '@mui/material/Grid';

import RawdemandFilterCriteria from './RawdemandFilterCriteria'
import RawdemandListImpl from './RawdemandListImpl'
import MyPageContainer from '../../core/template/MyPageContainer';
import {getListAPI} from './RawdemandAPI';
import {transformToCardFormat} from '../../core/js/FormUtils'
import {getPathVariable} from '../../core/js/UrlUtils';

import { useSearchParams } from "react-router-dom";
import { useSelector, useDispatch } from 'react-redux';
import {setRawdemandDashboardRawdemandList } from '../../store/slice/PharmaSlice';

export default function RawdemandListView({setShowEdit,setRawdemandId}){
    const {filterCriteria} = useSelector((state)=>state.pharmaslice.rawdemandDashboard);   

    const [filteredRawdemandList, setFilteredRawdemandList] = React.useState([]);
    const [cardList, setCardList] = useState([]);
    const [searchParams, setSearchParams] = useSearchParams();
    const { showfilter } = useSelector((state) => state.confslice);
    const { rawdemandDashboard } = useSelector((state) => state.pharmaslice);
    
    function dataFetchCallBack(){
    }

    useEffect(()=>{
      if (rawdemandDashboard.rawdemandList.length>-1){
        setFilteredRawdemandList(rawdemandDashboard.rawdemandList);
        transformToCardFormat(rawdemandDashboard.rawdemandList, setCardList);
      }
    },[rawdemandDashboard.rawdemandList])

    useEffect(()=>{
          transformToCardFormat(filteredRawdemandList, setCardList);
      },[filteredRawdemandList])

    useEffect(()=>{
        if (filterCriteria.title==='' && filterCriteria.qty==='' && filterCriteria.unit==='' && filterCriteria.status==='' && filterCriteria.rmid==='' && filterCriteria.vendorid==='' && filterCriteria.vendorname==='' && filterCriteria.price==='' ){
            setFilteredRawdemandList(rawdemandDashboard.rawdemandList);
            transformToCardFormat(rawdemandDashboard.rawdemandList, setCardList);

        } else {
            setFilteredRawdemandList(
                rawdemandDashboard.rawdemandList
                    .filter(rawdemand=> rawdemand.title.toString().toUpperCase().includes(filterCriteria.title.toString().toUpperCase()))
.filter(rawdemand=> rawdemand.status.toString().toUpperCase().includes(filterCriteria.status.toString().toUpperCase()))
.filter(rawdemand=> rawdemand.vendorname.toString().toUpperCase().includes(filterCriteria.vendorname.toString().toUpperCase()))

                
            )
            

            //transformToCardFormat(rawdemandDashboard.filteredRawdemandList, setCardList);
        }
      },[filterCriteria])
  
     return(
        <Grid container direction="column" >
            <Grid item lg={12}>
                <RawdemandListImpl
                    setShowEdit={setShowEdit}
                    setRawdemandId = {setRawdemandId}
                    tableList={filteredRawdemandList}
                    cardList={cardList}
                    />
          </Grid>
      </Grid>
    )
}